<dt-modal-content [showX]="false">
  <ng-template #title i18n>Import Fehler</ng-template>
  <ng-template #content>
    <p i18n>Dein Projekt kann nicht importiert werden. Entweder ist Deine Datei beschädigt oder das Format ist ungültig.</p>
  </ng-template>
  <ng-template #footer>
    <button mat-raised-button color="accent-less" (click)="dialogRef.close()" i18n>Schließen</button>
  </ng-template>
</dt-modal-content>
